import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus } from 'lucide-react';
import { DataTable } from '@/components/DataTable';
import { StatusBadge } from '@/components/StatusBadge';
import { useApi } from '@/hooks/useApi';

interface Job {
  id: string;
  title: string;
  department_name: string;
  job_type: string;
  location?: string;
  status: string;
  application_count: number;
  published_at?: string;
}

export function JobsPage() {
  const [status, setStatus] = useState('');
  const navigate = useNavigate();
  const { data, loading } = useApi<{ jobs: Job[] }>(`jobs?status=${status}`, [status]);

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between gap-4">
        <select value={status} onChange={e => setStatus(e.target.value)} className="bg-surface-2 border border-border rounded-lg px-3 py-2 text-sm text-foreground">
          <option value="">All Statuses</option>
          <option value="draft">Draft</option>
          <option value="open">Open</option>
          <option value="paused">Paused</option>
          <option value="closed">Closed</option>
          <option value="filled">Filled</option>
        </select>
        <button onClick={() => navigate('/jobs/new')} className="flex items-center gap-2 px-4 py-2 bg-amber-500 text-white rounded-lg text-sm font-medium hover:bg-amber-600">
          <Plus className="w-4 h-4" /> Create Job
        </button>
      </div>
      {loading ? <div className="text-muted-foreground">Loading...</div> : (
        <DataTable
          columns={[
            { key: 'title', header: 'Title', render: (r: Job) => <span className="font-medium">{r.title}</span> },
            { key: 'department_name', header: 'Department' },
            { key: 'job_type', header: 'Type', render: (r: Job) => <span className="capitalize">{r.job_type.replace('_', ' ')}</span> },
            { key: 'location', header: 'Location', render: (r: Job) => r.location ?? 'Remote' },
            { key: 'application_count', header: 'Applicants' },
            { key: 'status', header: 'Status', render: (r: Job) => <StatusBadge status={r.status} /> },
          ]}
          data={data?.jobs ?? []}
          onRowClick={(row) => navigate(`/jobs/${row.id}`)}
        />
      )}
    </div>
  );
}
